import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { auth, authTools } from 'config/firebase';
import { logoutUser } from 'store/actions/Auth';
import { AuthHelper } from 'utils/helpers/auth.helper';
import {
    SESSION_REPLACED_REASON,
    registerSessionReplaced,
    sessionReplaced
} from 'utils/session/SessionReplaced';

const SESSION_REPLACED_CHANNEL = 'session-replaced';

export const useSessionReplaced = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        const channel =
            typeof BroadcastChannel === 'undefined'
                ? null
                : new BroadcastChannel(SESSION_REPLACED_CHANNEL);

        registerSessionReplaced(async () => {
            channel?.postMessage(SESSION_REPLACED_REASON);

            try {
                AuthHelper.logoutUser();
                dispatch(logoutUser());
                await authTools.signOut(auth);
            } catch (error) {
                console.error('Auth Error: User unsuccessful in logging out', { error });
            }

            window.location.href = `/login?reason=${SESSION_REPLACED_REASON}`;
        });

        if (channel) {
            channel.onmessage = () => {
                if (auth.currentUser) {
                    sessionReplaced();
                }
            };
        }

        return () => channel?.close();
    }, [dispatch]);
};
